const YesNoNode = require('../YesNoNode');
const Q_poisoner = require('./Q_poisoner');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');

const Q_has_option = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new Q_poisoner(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'summon_option')) {
    node.branches[node.NO] = new UseAbility({
      actor,
      abilityHandle: 'summon_option',
      staticTarget: actor,
      altNode: node.branches[node.YES],
    });
  } else {
    node.branches[node.NO] = node.branches[node.YES];
  }

  node.yesNoEvalFunction = function () {
    return BattleCalc.getCondition(actor, 'has_option');
  };

  return node;
};
module.exports = Q_has_option;
